'use client';

import { useEffect, useState } from 'react';

/** Passe à `true` lorsque la page est défilée au-delà du seuil (px). */
export function useNavScroll(threshold = 60) {
  const [navScrolled, setNavScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setNavScrolled(window.scrollY > threshold);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return navScrolled;
}
